let currentLang = 'en';

export const setAxiosLang = (lang) => {
    currentLang = lang;
};

export const getAxiosLang = () => currentLang;
